import {Component, Inject, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {QuestionnaireService} from '../../../../services/questionnaire.service';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MatOptionSelectionChange} from '@angular/material/core';
import {ErrorDialogComponent} from '../../../user-actions/error-dialog/error-dialog.component';
import {HBIResults, Q_HBI} from '../../../../model/questionnaires/questionnaire-hbi';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {ActivatedRoute, Router} from '@angular/router';


export interface HbiDialogData {
  message: string;
  values: string[];
}

@Component({
  selector: 'app-questionnaire-hbi',
  templateUrl: './questionnaire-hbi.component.html',
  styleUrls: ['./questionnaire-hbi.component.css']
})
export class QuestionnaireHbiComponent implements OnInit {

  qForm: FormGroup;
  dataSource = Q_HBI;
  notFocused = false;
  submitted = false;
  show = false;
  displayedColumns = ['position', 'question', 'value'];
  values: string[] = [
    'Artralgia',
    'Uveite',
    'Eritema nodoso',
    'Ulcera aftoide',
    'Pioderma gangrenoso',
    'Fissurazione anale',
    'Comparsa di una nuova fistola',
    'Ascesso'];
  dialogResults = [''];
  dialogScore = 0;
  results = [];
  q = 'question';
  found = false;

  /// toolbar
  back = true;
  destination = '/questionnaires';
  title = 'HBI';
  user = null;
  uuid = null;
  authorization: boolean;
  doctorID: string;
  patientSSN: string;

  constructor(private questionnaireService: QuestionnaireService,
              public dialog: MatDialog,
              private route: ActivatedRoute,
              private router: Router) { }

  ngOnInit(): void {
    this.qForm = new FormGroup({
      question3: new FormControl({value: ''}, [Validators.required, Validators.min(0), Validators.max(25)]),
    });
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.dataSource.length; ++i) {
      this.results.push(null);
    }

    this.user = JSON.parse(localStorage.getItem('user'));
    this.route.params.subscribe(params => {
      this.doctorID = params.doctorID;
      this.patientSSN = params.patientSSN;
      this.uuid = params.uuid;
      this.authorization = this.user.ssn.localeCompare(params.patientSSN) === 0;
      if (params.back.localeCompare('questionnaires') === 0) {
        this.destination = 'questionnaires';
      } else if (params.back.localeCompare('choose-questionnaire') === 0) {
        this.destination = 'choose-questionnaire';
      }
    });
  }

  selectResult($event: MatOptionSelectionChange, value: string, position: number) {
    if ($event.isUserInput) {
      if (position !== 5) {
        this.results[position - 1] = value.slice(0, 1);
        console.log(this.results);
      } else {
        if (value === 'Si') {
          this.openHbiDialog($event, position, 'Presenza di complicanze');
        } else if (value === 'No') {
          this.results[position - 1] = '0';
          console.log(this.results);
        }
      }
    }
  }

  setResult(position: number) {
    const question = 'question' + position;
    if (position === 3) {
      this.results[position - 1] = this.qForm.get(question).value.toString();
    }
  }

  onSubmit(value) {
    this.submitted = true;
    this.show = true;
    this.found = false;

    if (this.results.length !== this.dataSource.length) {
      this.show = false;
      this.submitted = false;
      this.found = true;
      const msg = 'Non hai finito di completare il questionario!';
      this.openErrorDialog(msg);
    } else {
        for (const r of this.results) {
          if (r === null) {
            this.show = false;
            this.submitted = false;
            this.found = true;
            const msg = 'Non hai finito di completare il questionario!';
            this.openErrorDialog(msg);
            break;
          }
        }

        if (!this.found) {
          let finalScore = 0;

          for (let i = 0; i < this.results.length - 1; ++i) {
            finalScore += parseInt(this.results[i], 10);
          }

          finalScore += this.dialogScore;
          console.log(finalScore);
          const resultToSend = new HBIResults(this.doctorID, this.patientSSN, this.results, this.dialogResults, finalScore);
          this.questionnaireService.sendForm(resultToSend, 'hbi', this.uuid);
      }
    }
  }

  openErrorDialog(message: string): void {
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: '500px',
      height: '270px',
      data: message
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Finestra chiusa');
    });
  }

  openHbiDialog($event: MatOptionSelectionChange, position: number, message: string): void {
    const dialogRef = this.dialog.open(HbiDialogComponent, {
      width: '500px',
      height: '400px',
      data: {message, values: this.values}
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result === undefined) {
        this.openErrorDialog('Non hai effettuato alcuna selezione!');
        $event.source.deselect();
        this.results[position - 1] = null;
      } else {
        this.dialogResults = result;
        this.dialogScore = this.dialogResults.length;
        this.results[position - 1] = this.dialogScore.toString(10);
        }
      console.log('Finestra chiusa');
      console.log(this.results);
    });
  }

  goHome() {
    if (this.user === null) {
      this.router.navigateByUrl('/startup');
    } else {
      this.router.navigateByUrl('/landing');
    }
  }
}

@Component({
  selector: 'app-hbi-dialog',
  templateUrl: './hbi-dialog.component.html',
  styleUrls: ['./hbi-dialog.component.css']
})
export class HbiDialogComponent implements OnInit {

  results = [];

  constructor(public dialogRef: MatDialogRef<ErrorDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: HbiDialogData) { }

  ngOnInit(): void {
  }

  cancel() {
    this.dialogRef.close();
  }

  setResults($event: MatCheckboxChange, value: string) {
    if ($event.checked) {
      this.results.push(value);
    } else {
      this.results.forEach( (r, index) => {
        if (r.localeCompare(value) === 0) {
          this.results.splice(index, 1);
        }
      });
    }
    console.log(this.results);
  }
}
